<script setup lang="ts">
defineProps<{ icon: string }>()
</script>

<template>
  <div class="flex items-center gap-[0.6rem]">
    <UIcon :name="icon" class="min-w-[1.25em]" />
    <slot />
  </div>
</template>
